import styled, { css } from 'styled-components';

export const ClamshellPreview = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'inline' : 'none')};
`;

export const TemplateListingContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TemplateListingHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
`;

export const HeaderTitle = styled.div`
  font-size: 2rem;
  font-weight: 500;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    font-size: 1.5rem;
  }
`;

export const TemplateListingBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  ${({ theme }) => theme.breakpoints.down('xl')} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    padding: 1% 0%;
  }
`;

export const TemplateContainer = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius};
  background: ${({ theme }) => theme.palette.white};

  ${({ theme }) => theme.breakpoints.down('md')} {
    .quickAddToCart {
      transform: translateY(0%);
      visibility: visible;
    }
  }

  &:hover {
    .bookmark {
      opacity: 1;
    }
    .quickAddToCart {
      margin-bottom: 3%;
      transform: translateY(0%);
      visibility: visible;
    }
  }
`;

export const TemplateBody = styled.div<{ isLoading: boolean }>`
  opacity: ${({ isLoading }) => (isLoading ? '0.3' : 1)};
`;

export const ImageWrapper = styled.div``;

export const ProductImage = styled.div`
  max-width: 255px;
  height: 200px;
  position: relative;
  margin: 0 auto;
`;

export const QuickAddToCart = styled.div`
  ${({ theme }) => theme.breakpoints.down('md')} {
    background-color: unset;
    padding: 5% 0%;
  }

  visibility: hidden;
  background: rgba(242, 242, 242, 1);
  border-radius: ${({ theme }) => theme.borderRadius};
  position: absolute;
  bottom: 0px;
  width: 95%;
  padding: 6% 0%;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 400;
  z-index: 2;
  div:first-of-type {
    padding: 2%;
  }

  left: 0;
  right: 0;
  margin: 0 auto;
  transform: translateY(10%);
  transition: transform 300ms;
`;

export const ButtonWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
`;

export const ProductTitle = styled.div`
  font-weight: 500;
  margin-top: 10px;
  text-align: center;
`;

export const ProductDetails = styled.div`
  position: relative;
  font-size: 1.1rem;
  min-height: 30px;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 10px;
`;

export const EditWrapper = styled.div``;

export const DeleteWrapper = styled.div``;

const getMenuPostion = (
  left?: string,
  right?: string,
  top?: string,
  bottom?: string
) => {
  return css`
    left: ${left ? left : 'auto'};
    right: ${right ? right : 'auto'};
    top: ${top ? top : 'auto'};
    bottom: ${bottom ? bottom : 'auto'};
  `;
};

export const Menu = styled.div<{
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
}>`
  position: absolute;
  background: white;
  z-index: 5;
  box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px -3px,
    rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px;
  border-radius: ${({ theme }) => theme.borderRadius};

  right: 0px;
  transition: opacity 151ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    transform 167ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  /* ${({ left, right, top, bottom }) =>
    getMenuPostion(left, right, top, bottom)} */
  /* transform: translateY(100%); */
  right: 10px;
`;
export const MenuItem = styled.div`
  padding: 10px;
  width: 150px;
  &:hover {
    background: ${({ theme }) => theme.palette.grey13};
  }
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-evenly; ;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 20;
  opacity: 1;
`;

export const DisclaimerCustom = styled.div`
  font-size: 0.85rem;
  text-align: center;
`;
